export class GetListGuideGrievanceNotificationToCardPageRequest {
    public idGrievanceNotificationStatus: number;
    public idEpisode: number;
    public idPatient: number;
    public patientCpf: string;
    public patientCns: string;
    public datetimeInclusion: Date;
    public page: number;
    public pageSize: number;
    public idModule: number;
}